import { createFileRoute } from '@tanstack/react-router'

import { preloadListDevices } from '@/api/react-query'

export const Route = createFileRoute('/_authenticated/settings/devices')({
	loader: async ({ context }) => await preloadListDevices(context, {}),
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.Devices.Title()
	}
})
